import 'mlmi-library'
import { getCookie, setCookie } from 'mlmi-library/utils/cookies'
import { TRANSITION_END } from 'mlmi-library/utils/animation'
import { CoreDetect_WebP } from 'mlmi-library/utils/device'
import Carousel, { Carousel_CoreInit } from 'mlmi-library/components/carousel/v1/carousel'
import Mobile from 'mlmi-library/modules/mobile/v1/mobile'
import Navigation from 'mlmi-library/modules/navigation/v1/navigation'
import Scrollbar from 'mlmi-library/components/scrollbar/v1/scrollbar'
import Burger from 'mlmi-library/components/burger/v1/burger'
import 'mlmi-library/components/fade-in/v1/fade-in'
import 'bootstrap/js/dist/collapse'
import '@fancyapps/fancybox'
import 'mlmi-library/components/fixed-content/v1/fixed-content'

export { Burger, Mobile, Carousel_CoreInit, Navigation, Scrollbar, setCookie, getCookie, TRANSITION_END }

CoreDetect_WebP()
